import { Badge } from "@/components/ui/badge"
import type { UserRole, TeamMembershipRole } from "@/types"

const roleLabels: Record<UserRole, string> = {
  user: "Utilisateur",
  admin: "Administrateur",
}

const roleVariants: Record<UserRole, "default" | "secondary" | "outline" | "destructive"> = {
  admin: "default",
  user: "outline",
}

export function RoleBadge({ role }: { role: UserRole }) {
  return <Badge variant={roleVariants[role]}>{roleLabels[role]}</Badge>
}

const teamRoleLabels: Record<TeamMembershipRole, string> = {
  member: "Membre",
  manager: "Manager",
}

const teamRoleVariants: Record<TeamMembershipRole, "default" | "secondary" | "outline" | "destructive"> = {
  manager: "secondary",
  member: "outline",
}

export function TeamRoleBadge({ role }: { role: TeamMembershipRole }) {
  return <Badge variant={teamRoleVariants[role]}>{teamRoleLabels[role]}</Badge>
}
